"use client";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/attrchange/ls.attrchange";
import React, { useState } from "react";
import Imgix from "react-imgix";

import { getComputedSizes } from "@stadium/helpers/device";

import {
  mobileScreenType,
  tabletScreenType,
  desktopScreenType,
  largeDisplayScreenType,
} from "@stadium/constants";

const getFormattedUrl = (url, paramsToDelete = []) => {
  // URL here should be available in both browser and node
  // hence no need to add a check for window
  const formattedSrc = new URL(url);
  paramsToDelete.map((param) => formattedSrc.searchParams.delete(param));
  return formattedSrc.href;
};

const PrismicImgix = ({
  src,
  mobile,
  tablet,
  desktop,
  largeDisplay,
  className,
  isAsset = false,
  lazyload = false,
  lazySizesEnabled = true,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(lazyload);
  const onLoad = () => setIsLoading(false);

  if (!src) {
    return "";
  }

  const computedSizes = getComputedSizes({
    [mobileScreenType]: mobile,
    [tabletScreenType]: tablet,
    [desktopScreenType]: desktop,
    [largeDisplayScreenType]: largeDisplay,
  });
  const formattedUrl = isAsset ? src : getFormattedUrl(src, ["w", "h", "fit"]);
  const lazySizeClass = lazySizesEnabled ? "lazyload" : "";
  const attributeConfig = lazySizesEnabled
    ? {
        src: "data-src",
        srcSet: "data-srcset",
        sizes: "data-sizes",
      }
    : {};

  if (!formattedUrl) {
    return "";
  }

  return (
    <>
      {lazyload && isLoading && (
        <div style={{ width: desktop, height: "20px" }} className="animated-background" />
      )}
      <Imgix
        className={`${className} ${lazySizeClass}`}
        src={formattedUrl}
        sizes={computedSizes}
        imgixParams={{ fit: "clip" }}
        htmlAttributes={{
          ...rest,
          onLoad,
        }}
        attributeConfig={attributeConfig}
      />
    </>
  );
};

export default PrismicImgix;
